// extracted by mini-css-extract-plugin
export default {"formBox":"xoL9AEdyq96gVPj1cOuS","addBtnBox":"RlQ9HDdkQo6foDe0ruH6"};